var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bodyClassObject},[_c('div',{staticClass:"wrapper"},[_c('HeaderComponent'),_c('MenuComponent',{attrs:{"active":"dashboard"}}),_c('HomeContentComponent'),_c('FooterComponent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }